/**
 * Abre um data URI (ex: "data:application/pdf;base64,...") em uma nova aba do navegador.
 *
 * Navegadores modernos (Chrome, Edge) bloqueiam navegação direta para data: URIs por segurança.
 * Para contornar, o data URI é convertido em um Blob URL (blob:http://...), que é aceito
 * por todos os navegadores (Chrome, Firefox, Edge, etc).
 *
 * Se o popup for bloqueado (ex: bloqueador de popups ativo), faz download direto do arquivo.
 */
export const openDataUri = (dataUri) => {
  // Separa o cabeçalho (ex: "data:application/pdf;base64") do conteúdo em base64
  const [header, contentBase64] = dataUri.split(',');

  // Extrai o MIME type do cabeçalho (ex: "application/pdf")
  const mimeMatch = header.match(/data:(.*?);/);
  const mimeType = mimeMatch ? mimeMatch[1] : 'application/octet-stream';

  // Decodifica o base64 para bytes binários
  const decodedString = atob(contentBase64);
  const byteArray = new Uint8Array(decodedString.length);
  for (let i = 0; i < decodedString.length; i++) {
    byteArray[i] = decodedString.charCodeAt(i);
  }

  // Cria um Blob (objeto binário) e gera uma URL temporária do browser (blob:http://...)
  const blob = new Blob([byteArray], { type: mimeType });
  const blobUrl = URL.createObjectURL(blob);

  // Tenta abrir em nova aba
  const newWindow = window.open(blobUrl, '_blank');

  // Fallback: se o popup foi bloqueado, faz download direto do arquivo
  if (!newWindow) {
    const downloadLink = document.createElement('a');
    downloadLink.href = blobUrl;
    downloadLink.download = 'comprovante.pdf';
    downloadLink.click();
  }
};
